"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var ChevronRightIcon = function ChevronRightIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    width: "12",
    height: "22",
    viewBox: "0 0 12 22"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.38254 21.5C0.777735 21.5 0.3125 21.0167 0.3125 20.3884C0.3125 20.0863 0.44044 19.8084 0.626534 19.603L9.08218 11L0.626534 2.39701C0.44044 2.1916 0.3125 1.90161 0.3125 1.61162C0.3125 0.983314 0.777735 0.5 1.38254 0.5C1.67331 0.5 1.94082 0.620829 2.13855 0.83832L11.3502 10.1904C11.5712 10.3959 11.6875 10.6858 11.6875 11C11.6875 11.3021 11.5712 11.58 11.3502 11.8096L2.13855 21.1738C1.92919 21.3792 1.67331 21.5 1.38254 21.5Z"
  }));
};
var _default = ChevronRightIcon;
exports.default = _default;